const CLASS_NAME = ".js-fade-in-scroll";

const init = () => {
  gsap.utils.toArray(CLASS_NAME).forEach((elm) => {
    ScrollTrigger.create({
      trigger: elm,
      once: true,
      onEnter: () => {
        gsap.to(elm, { autoAlpha: 1 });
      },
    });
  });
};

export { init };
